import React, { Component } from 'react';
import { Card } from 'material-ui/Card';
import Alert from 'react-s-alert';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change, reset } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { renderAutoCompleteSingleSelect, renderCheckBox, renderDateField, renderTextField } from '../../../../components/reduxFields';
import { deleteUploadedDocument, documentUploadDownload, uploadedDocumentDownload, PreviewDownloadedDocument, getUserDocumentSubFolderList, BatchInactiveDocuments, BatchActiveDocuments, BatchDeleteDocuments, deleteUserDocumentSubFolder  } from '../../../patients/actions/PatientActions';
import { getMasterData, getStaffsAndPatientsByLocation } from '../../actions/UserActions';
import UploadDocumentModal from './staff_Document_Upload_Modal';
import SubFoldersModal from './subFolders_Modal';
import JPG from '../../../../img/jpg.png';
import DOC from '../../../../img/doc.png';
import EXCEL from '../../../../img/excel.png';
import OTHER from '../../../../img/other.png';
import PDF from '../../../../img/pdf.png';
import PNG from '../../../../img/png.png';
import PPT from '../../../../img/ppt.png';
import TXT from '../../../../img/txt.png';
import moment from 'moment';
import { showWarningMessage, alertConfirmation, showFormatedDate, isEmptyObject } from '../../../../actions/utilAction';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import SortingCustom from '../../../../components/SortingCustom';
import PaginatorCustom from '../../../../components/paginationCustom';
import DocumentSubFolderDetails from './DocumentSubFolderDetails';
import MoveBatchDocumentsIntoFolderModal from './MoveBatchDocumentsIntoFolderModal';
import folderNames from '../../../../constants/FolderNameConstant';

const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};

class DocumentSubFolderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openSubFolder: false,      
      staffId: (props.staffId ? props.staffId : null),
      //documentTypes: [],
      staffDocs: [],
      userId: (props.userId ? props.userId : null),      
      ShowOnlyExpiredDocuments: false,
      ShowOnlyInactiveDocuments: false,
      documentTypeId: 0,
      uploadDocumentObj: [], 
      masterFolderId: (props.masterFolderIdForSubFolder ? props.masterFolderIdForSubFolder : null),
      masterFolderName: (props.folderName ? props.folderName : ''),
      subFolderId: null,      
      isSubDetails: false,
      openBatchMoveModal: false,
      selectedDocumentIds: [],      
      userDocumentMasterFolders: [],
      userDocumentSubFolders: [],
    };
    this.filter = {
      sort_Column: '',
      sort_order: '',     
      searchText: '',
    };
    this.handleCloseHandler = this.handleCloseHandler.bind(this);
    this.uploadDocumenthandler = this.uploadDocumenthandler.bind(this);
    this.handleAlertClick = this.handleAlertClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    //this.handleNewRequest = this.handleNewRequest.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSubFolderAlertClick = this.handleSubFolderAlertClick.bind(this);
    this.handleEditSubFolderClick = this.handleEditSubFolderClick.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleMoveFolderDocumentClick = this.handleMoveFolderDocumentClick.bind(this);    
  }

  loadDataList() {
    let searchObj = {
      userId: this.state.userId,
      fromDate: this.props.selectorStartDate ? moment(this.props.selectorStartDate).format('YYYY-MM-DDTHH:mm:ss') : moment('1990-01-01').format('YYYY-MM-DDTHH:mm:ss'),
      toDate: this.props.selectorEndDate ? moment(this.props.selectorEndDate).format('YYYY-MM-DDTHH:mm:ss') : moment().format('YYYY-MM-DDTHH:mm:ss'),
      documentTypeId: this.state.documentTypeId,
      showOnlyExpiredDocuments: this.state.ShowOnlyExpiredDocuments ? true : false,      
      showOnlyInactiveDocuments: this.state.ShowOnlyInactiveDocuments ? true : false,  
      masterFolderId : this.state.masterFolderId,
      subFolderId : null,
      searchText: this.filter.searchText || '',  
    };
    this.props.documentUploadDownload(searchObj); // For Listing of uploaded documents
  }

  loadSubFolderData(page_number) {   
    let searchObj1 = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: 
      {         
        userId: this.state.userId,
        masterFolderId: this.state.masterFolderId,
        userTypeName: "STAFF",      
      },
    };

    this.props.getUserDocumentSubFolderList(searchObj1); // For Listing of Sub Folders
  }



  componentWillMount() {
    this.props.getMasterData('MASTERDOCUMENTTYPESSTAFF,USERDOCUMENTMASTERFOLDER,USERDOCUMENTSUBFOLDER');

    this.setState({ userId: this.props.userId || null, staffId: this.props.staffId || null, masterFolderId: this.props.masterFolderIdForSubFolder || null, masterFolderName: this.props.masterFolderName || ''}, () => {
      if (this.state.userId) {
        this.loadSubFolderData();
        this.loadDataList();        
      } 
      // else {
      //   let searchObj = {
      //     locationIds: '0',
      //     permissionKey: 'SCHEDULING_LIST_VIEW_OTHERSTAFF_SCHEDULES',
      //     isActiveCheckRequired: 'YES',
      //   };
      //   this.props.getStaffsAndPatientsByLocation(searchObj);
      // }
    });
  }
  
  componentWillReceiveProps(nextProps) {
    //if (nextProps.masterData && nextProps.masterData !== this.props.masterData) {
      //this.setState({ documentTypes: nextProps.masterData.masterDocumentTypesStaff });
      this.setState({ userDocumentMasterFolders: nextProps.masterData.userDocumentMasterFolder });
      this.setState({ userDocumentSubFolders: nextProps.masterData.userDocumentSubFolder });
    //}
    if (nextProps.staffDocs && this.props.staffDocs !== nextProps.staffDocs) {      
      this.setState({ staffDocs: nextProps.staffDocs });
    }
    // if (nextProps.staffsList && nextProps.staffsList.length > 0 && nextProps.staffsList !== this.props.staffsList && this.state.staffId) {
    //     let id=parseInt(this.state.staffId);
    //     this.props.dispatch(change('DocumentSubFolderListingForm', 'Staffs', id));
      
    //     let userId = null;
    //     let selectedStaff = (nextProps.staffsList || []).find((staffObj) => staffObj.id === id);
    //     if (selectedStaff) {
    //       userId = selectedStaff.userId || null;
    //     }
    //     this.setState({ userId: userId }, () => {
    //       if (this.state.userId) {
    //         this.loadDataList();
    //       } else {
    //         this.setState({ staffDocs: [] });
    //       }
    //     });
    // }

    if (nextProps.saved_userDocumentSubFolder && nextProps.saved_userDocumentSubFolder !== this.props.saved_userDocumentSubFolder) {
      this.props.getMasterData('MASTERDOCUMENTTYPESSTAFF,USERDOCUMENTMASTERFOLDER,USERDOCUMENTSUBFOLDER');
      this.loadSubFolderData();
    }
    
    if (nextProps.saved_MoveBatchDocumentsIntoFolder && nextProps.saved_MoveBatchDocumentsIntoFolder !== this.props.saved_MoveBatchDocumentsIntoFolder) {
      this.ResetAllDocuments();
      this.loadSubFolderData();
      this.loadDataList();
    }   

    if (nextProps.inactivated_MoveBatchDocuments && nextProps.inactivated_MoveBatchDocuments !== this.props.inactivated_MoveBatchDocuments) {
      this.ResetAllDocuments();            
      this.loadDataList();
    }  

    if (nextProps.deleted_MoveBatchDocuments && nextProps.deleted_MoveBatchDocuments !== this.props.deleted_MoveBatchDocuments) {
      this.ResetAllDocuments();      
      this.loadDataList();
    }  
    
    if (nextProps.deleted_UserDocumentSubFolder && nextProps.deleted_UserDocumentSubFolder !== this.props.deleted_UserDocumentSubFolder) {
     // this.ResetAllDocuments();      
      this.loadSubFolderData();
    }  
    
  }

  uploadDocumenthandler = () => {
    if (!this.state.userId) {
      showWarningMessage('Please select staff to upload document!');
      return false;
    } else {
      this.setState({ open: true, uploadDocumentObj: null });
    }
  }

  handleClose = () => {
    this.setState({
      openBatchMoveModal: false,
      selectedDocumentIds: [],      
    });
    // this.props.loadClaimsData();
    this.props.handleReset();
    this.props.dispatch(reset('DocumentSubFolderListingForm', 'Chkclaim', null))
  }

  handleCloseHandler = () => {
    this.setState({ open: false, openSubFolder: false, subFolderId: null });
  };

  handleDownloadClick = (docId, fileName) => {
    this.props.uploadedDocumentDownload(docId, fileName,folderNames.MASTER);
  }

  handlePreviewClick = (docId, fileName) => {
    Alert.closeAll();
    this.props.PreviewDownloadedDocument(docId, fileName);
  }

  handleEditClick = (Obj) => {
    // console.log('Obj..............',Obj)
   this.setState({ open: true, uploadDocumentObj: Obj});
    Alert.closeAll();
  }

  onClickHandler = (e, obj) => {
      this.setState({
        subFolderId: obj.id,
        isSubDetails: true,
        subFolderName: obj.subFolderName
      })
      //this.loadSubFolderData()
  }

  onBackClick = () => {
      this.setState({
        subFolderId: null,
        isSubDetails: false,
        subFolderName: ''
      })
      this.loadSubFolderData();
      this.loadDataList();
  }

  handleAlertClick = (docId) => {
    this.props.deleteUploadedDocument(docId, this.state.userId,folderNames.MASTER);
    Alert.closeAll();
  }
  handleDeleteClick = (docId) => {
    let warningMsg = 'Are you sure you want to delete this document?';
    alertConfirmation(warningMsg, {
      customFields: {
        displayComponent: true,
        handleButtonClick: () => this.handleAlertClick(docId),
        id: docId,
      },
    });
  }


  // handleNewRequest(input, selectedRecord) {
  //   input.onChange(selectedRecord.value);
    
  //   if (input.name === 'Staffs') {
  //     let userId = null;
  //     let selectedStaff = (this.props.staffsList || []).find((staffObj) => staffObj.id === selectedRecord.value);
  //     if (selectedStaff) {
  //       userId = selectedStaff.userId || null;
  //     }
  //     this.setState({ userId: userId }, () => {
  //       if (this.state.userId) {
  //         this.loadSubFolderData();
  //         this.loadDataList();          
  //       } else {
  //         this.setState({ staffDocs: [] });
  //       }
  //     });
  //   }
  //   else if (input.name === 'documentType') {
  //     this.setState({
  //       documentTypeId: selectedRecord.value,
  //     },()=>  this.loadDataList());
  //   } 
  // }

  onDateChange(input, date) {
    input.onChange(date);
    if (this.state.userId) {
      this.loadDataList();
    }
  }

  handleReset() {
    this.props.dispatch(change('DocumentSubFolderListingForm', 'startDate', null));
    this.props.dispatch(change('DocumentSubFolderListingForm', 'endDate', null));
    this.props.dispatch(change('DocumentSubFolderListingForm', 'documentType', null));
    this.props.dispatch(change('DocumentSubFolderListingForm', 'ShowOnlyExpiredDocuments', false));
    this.props.dispatch(change('DocumentSubFolderListingForm', 'ShowOnlyInactiveDocuments', false));    
    this.setState({
        ShowOnlyExpiredDocuments: false,
        ShowOnlyInactiveDocuments: false,
        documentTypeId: 0
      },()=>{this.loadDataList()});
  };

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadDataList();
      });
  }

  handleOpen = () => {
    Alert.closeAll();
    this.setState({ openSubFolder: true, subFolderId: null });
  };

  handleEditSubFolderClick = (event, obj) => {
    Alert.closeAll();
    this.setState({ openSubFolder: true, subFolderId: obj.id });
}

handleMoveFolderDocumentClick = (event, Obj) => {
  Alert.closeAll();
  this.setState({
    openBatchMoveModal : true,
    selectedDocumentIds: Obj.documentIds.toString().trim()
  })
}

handleSubFolderAlertClick = (event, subFolderId) => {
    this.props.deleteUserDocumentSubFolder(subFolderId);
    Alert.closeAll();
}

handleDeleteSubFolderClick = (event, obj) => {
    alertConfirmation('Are you sure you want to delete sub folder?', {
        customFields: {
            displayComponent: true,
            handleButtonClick: this.handleSubFolderAlertClick,
            id: obj.id,
        },
    });
}


CheckDocument(e, index, data) {  
  let selectedDocumentIds = this.state.selectedDocumentIds;

  let isDocumentChecked = e.target.checked;
  if (isDocumentChecked) {    
    selectedDocumentIds.push(data.id);
  } else {    
    index = selectedDocumentIds.findIndex((value) => value === data.id);
    if (index >= 0) {
      selectedDocumentIds.splice(index, 1);
    }
  }
  this.setState({ selectedDocumentIds });
}

handleMoveDocumentClick = () => {
  this.setState({
    openBatchMoveModal : true
  })
}

ResetAllDocuments() { 
  if(!isEmptyObject(this.state.staffDocs))
  {
    let staffDocs = this.state.staffDocs;  
    staffDocs.forEach((obj, Index) => {
      let documentIdCheck = `Documents[${Index}].Chk`;
      this.props.dispatch(change('DocumentSubFolderListingForm', documentIdCheck, false));
    });  
  }
  this.setState({ staffDocs:[], selectedDocumentIds : [] });
}

handleSelectAllClick= (e, isAllDocumentChecked) => {  
  let staffDocs = this.state.staffDocs;  
  let selectedDocumentIds = [];
  if(staffDocs && staffDocs.length > 0) {
    staffDocs.forEach((obj, Index) => {    
      let documentIdCheck = `Documents[${Index}].Chk`;
      if (obj && isAllDocumentChecked) {      
        selectedDocumentIds.push(obj.id);
        this.props.dispatch(change('DocumentSubFolderListingForm', documentIdCheck, true));
      } else {
        this.props.dispatch(change('DocumentSubFolderListingForm', documentIdCheck, false));
      }
    });
  }
  this.setState({  selectedDocumentIds });
}

handleAlertInactiveDocumentsClick = (event) => {
  this.props.BatchInactiveDocuments(this.state.selectedDocumentIds.toString(),folderNames.MASTER);
  Alert.closeAll();
}

handleBatchInactiveDocuments = (event) => {
  Alert.warning('Are you sure you want to inactive selected documents?', {
    position: 'bottom-right',
    effect: 'slide',
    timeout: 10000,
    customFields: {
      displayComponent: true,
      handleButtonClick: this.handleAlertInactiveDocumentsClick,
      //id: obj.id,
    },
  });
}

handleAlertActiveDocumentsClick = (event) => {
  this.props.BatchActiveDocuments(this.state.selectedDocumentIds.toString(),folderNames.MASTER);
  Alert.closeAll();
}

handleBatchActiveDocuments = (event) => {
  Alert.warning('Are you sure you want to active selected documents?', {
    position: 'bottom-right',
    effect: 'slide',
    timeout: 10000,
    customFields: {
      displayComponent: true,
      handleButtonClick: this.handleAlertActiveDocumentsClick,
      //id: obj.id,
    },
  });
}


handleAlertDeleteDocumentsClick = (event) => {
  this.props.BatchDeleteDocuments(this.state.selectedDocumentIds.toString(),folderNames.MASTER);
  Alert.closeAll();
}

handleBatchDeleteDocuments = (event) => {
  Alert.warning('Are you sure you want to delete selected documents?', {
    position: 'bottom-right',
    effect: 'slide',
    timeout: 10000,
    customFields: {
      displayComponent: true,
      handleButtonClick: this.handleAlertDeleteDocumentsClick,
      //id: obj.id,
    },
  });
}

handleSearchChange(event) {
  if (event.target.value.length > 2) {
    this.filter.searchText = event.target.value;
    this.loadDataList();
  } else if (event.target.value.length === 0) {
    this.filter.searchText = '';
    this.loadDataList();
  }
}


closeDialog = () => {     
  this.setState({ openBatchMoveModal: false,  selectedDocumentIds: [] });
}

renderDownloadDocsList = () => {  
    if ((this.state.staffDocs && this.state.staffDocs.length === 0) || (this.state.staffDocs.length === undefined)) {
      return (
        <div className="col-sm-12 mt20">
          <div className="familydl text-center no-record">
              No document found.
          </div>
        </div>
      );
    }
    let extension;
    if (this.state.staffDocs && this.state.staffDocs.length > 0) {
      // console.log('this.state.staffDocs-------', this.state.staffDocs);
      return this.state.staffDocs.map((obj, index) => {
        extension = obj.url.split('.').pop();
        let extensionArr = ['jpg', 'jpeg', 'png', 'txt', 'docx', 'doc', 'xlsx', 'pdf', 'pptx'];
        let fileExtensionCheck = extensionArr.find((o) => o === extension);
        if (fileExtensionCheck) {
          let imgUrl = '';
          if (fileExtensionCheck === 'jpg' || fileExtensionCheck === 'jpeg') {
            imgUrl = JPG;
          } else if (fileExtensionCheck === 'png') {
            imgUrl = PNG;
          } else if (fileExtensionCheck === 'txt') {
            imgUrl = TXT;
          } else if (fileExtensionCheck === 'pdf') {
            imgUrl = PDF;
          } else if (fileExtensionCheck === 'docx' || fileExtensionCheck === 'doc') {
            imgUrl = DOC;
          } else if (fileExtensionCheck === 'xlsx') {
            imgUrl = EXCEL;
          } else if (fileExtensionCheck === 'pptx') {
            imgUrl = PPT;
          } else {
            imgUrl = OTHER;
          }
          return (
            <div className="col-sm-6 history_card mt20" key={index}>
              <Card>
                <div className="cardchkbtn">                
                  <Field
                    name={`Documents[${index}].Chk`}
                    component={renderCheckBox}
                    onChange={(e) => this.CheckDocument(e, index, obj)}
                    style={stylescss.checkbox}
                  />                  
                </div>
                <div className="clearfix"></div> 
                <div className="cardactbtn">                
                  {this.props.deletePermission ?
                    <button onClick={(e) => this.handleEditClick(obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null}
                  {this.props.downloadPermission ?
                      <button onClick={(e) => this.handlePreviewClick(obj.id, obj.url)} type="button" title="Preview" className="tbactionbtn bluefont"><i className="fa fa-eye" aria-hidden="true"></i></button>
                      : null}
                  {this.props.downloadPermission ?
                    <button onClick={(e) => this.handleDownloadClick(obj.id, obj.url)} type="button" title="Download" className="tbactionbtn bluefont"><i className="fa fa-download" aria-hidden="true"></i></button>
                    : null}
                  {this.props.deletePermission ?
                    <button onClick={(e) => this.handleDeleteClick(obj.id)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                    : null}
                  <div className="filetype">
                    <img src={imgUrl} alt="text" title={obj.url} />
                  </div>
                </div>
                <div className="carditems">
                  <ul>
                    <li>Document Title: <span>{obj.documentTitle}</span></li>
                    <li>Document Type: <span>{obj.documentTypeNameStaff}</span></li>
                    <li>Uploaded Date: <span>{showFormatedDate(obj.createdDate || new Date())}</span></li>
                    {!obj.expiration ? <li>Expiration Date: <span>No Expiration</span> </li> : <li>Expiration Date: <span>{moment(obj.expiration).format('MM/DD/YYYY')}</span></li>}
                    <li>Active Document: <span className={obj.isActive === true ? 'greenfont' : 'redfont'}>{obj.isActive ? 'Yes' : 'No'}</span></li>
                  </ul>
                </div>
              </Card>
            </div>
          );
        }
      });
    }
  }

  renderDocumentListingPanel() {
    return (
      <div>           
          {this.state.isSubDetails === false ?
          <div>
           <h2 className="page_title">Manage Folders {' > '} {this.state.masterFolderName} {' > '} Sub Folders</h2>
           <div className="clearfix"></div>     
          <div>              
              <div className="row">                           
                {/* <div className="col-sm-4 mt-30">
                  <Field
                    name="Staffs"
                    label="Staff"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.staffsList}
                    component={renderAutoCompleteSingleSelect}/>
                </div> */}
                
                <div className="col-sm-4">
                  <Field
                    name="startDate"
                    placeholder="From Date"
                    onDateChange={this.onDateChange}
                    selected={this.props.selectorStartDate}
                    component={renderDateField}/>
                </div>
                <div className="col-sm-4">
                  <Field
                    name="endDate"
                    placeholder="To Date"
                    onDateChange={this.onDateChange}
                    selected={this.props.selectorEndDate}
                    component={renderDateField}/>
                </div>  
                <div className="col-sm-4 mt-30">
                  <Field
                      name="documentType"
                      label="Document Type"
                      component={renderAutoCompleteSingleSelect}
                      options={this.props.masterDocumentTypesStaff}
                      handleNewRequest={this.handleNewRequest}
                    />
                </div>                
              </div>
              <div className="row">     
                <div className="col-sm-4">
                    <Field
                      name="staffDocs"
                      floatingLabelText="Search"
                      maxLength='25'
                      onChange={this.handleSearchChange}
                      component={renderTextField}
                    />
                </div>           
                <div className="col-sm-3 mt-30">
                    <Field
                        name="ShowOnlyExpiredDocuments"
                        label="Show expired documents only"
                        component={renderCheckBox}
                        onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowOnlyExpiredDocuments')}
                      />
                </div>      
                <div className="col-sm-3 mt-30">
                    <Field
                        name="ShowOnlyInactiveDocuments"
                        label="Show inactive documents only"
                        component={renderCheckBox}
                        onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowOnlyInactiveDocuments')}
                      />
                </div>                        
                <div className="reset-btn col-sm-2 mt-30 btn_rt">
                  <CommonButton className="grey_btn" onTouchTap={this.handleReset} label = 'Reset' />
                </div>                  
            </div>
          </div>
          </div>: null}

          {this.props.uploadPermission && this.state.isSubDetails === false ?
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 reset-btn claims_btn">
                  <RaisedButton label="Back" primary={true} onTouchTap={() => this.props.onBackClick()} />
                  <CommonButton className="ml_15 mt-20" label="Upload Document" primary={true} onTouchTap={this.uploadDocumenthandler} />
                  <RaisedButton className={"grey_btn ml_15"}  onTouchTap={(e) => this.handleSelectAllClick(e, (this.state.selectedDocumentIds.length > 0  ? false : true))} >{this.state.selectedDocumentIds.length > 0 ? "Deselect All" : "Select All"}</RaisedButton>
                  <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleMoveDocumentClick(e)} >Bulk Move Documents</RaisedButton>
                  <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchInactiveDocuments(e)} >Bulk Inactive Documents</RaisedButton>
                  <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchActiveDocuments(e)} >Bulk Active Documents</RaisedButton>
                    <RaisedButton className={this.state.selectedDocumentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"}  disabled={this.state.selectedDocumentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchDeleteDocuments(e)} >Bulk Delete Documents</RaisedButton>
              </div>
            </div>
          : null}
        <div className="row">
          {this.state.userId ?  this.state.isSubDetails == false ? this.subFoldersRender() : 
                  <DocumentSubFolderDetails
                  masterFolderId={this.state.masterFolderId}  
                  masterFolderName={this.state.masterFolderName}
                  userId={this.state.userId}
                  staffId={this.state.staffId}
                  subFolderId={this.state.subFolderId}  
                  subFolderName={this.state.subFolderName}
                  onBackClick={this.onBackClick}/>
        : null}

          <div className="clearfix"></div>
          {!this.state.userId ?
            (<div className="col-sm-12 mt20">
              <div className="familydl text-center no-record">
                    No staff selected.
              </div>
            </div>)
            :  this.state.isSubDetails === false && this.renderDownloadDocsList()}

          {
            this.state.openBatchMoveModal === true && <MoveBatchDocumentsIntoFolderModal
            folderType="MASTER FOLDER"
            selectedDocumentIds={this.state.selectedDocumentIds}
            userDocumentMasterFolders={this.state.userDocumentMasterFolders.filter((obj) => obj.userId === this.state.userId && obj.userTypeName === 'STAFF')}
            userDocumentSubFolders={this.state.userDocumentSubFolders.filter((obj) => obj.userId === this.state.userId)}
            closeDialog={this.closeDialog}
            />
          }
        </div>
      </div>
    );
  }


  subFoldersRender = () => {
    const { handleSubmit, userDocumentSubFolderData } = this.props;
    let userDocumentSubFolderList = (userDocumentSubFolderData && userDocumentSubFolderData.data) || [];
    let userDocumentSubFolderMeta = (userDocumentSubFolderData && userDocumentSubFolderData.meta) || null
    const tableClass = classNames({
        'table': true,
        'table-striped': this.props.condensed,
        'table-bordered': this.props.bordered,
        'table-hover': true,
        'table-condensed': this.props.condensed,
        'customtable': true,
    });
    return (
        <div className="col-sm-12">
        {/* <h2 className="page_title">Manage Sub Folders</h2>
        <div className="clearfix"></div> 
          <div className="readmin-panel"> */}
            <div className="panel-body">
                <div className="modalwindow">
                    <div className="row">
                        <div className="col-sm-5">
                            {this.props.uploadPermission ? 
                                <div>
                                    <RaisedButton label="Add Sub Folder" primary={true} onTouchTap={this.handleOpen} />
                                </div>
                              : null} 
                        </div>
                        {/* <div className="col-sm-7">
                            <div className="row end-flex">
                                <div className="col-sm-6 mtm-27">
                                    <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchCurriculumLibraries)}>
                                        <Field
                                            name="curriculumLibraries"
                                            floatingLabelText="Search"
                                            maxLength='25'
                                            onChange={this.handleSearchChange}
                                            component={renderTextField}
                                        />
                                    </form>
                                </div>
                                <div className="reset-btn col-sm-3 btn_rt">
                                    <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                                </div>
                            </div>
                        </div> */}
                    </div>                    
                    {this.state.openSubFolder && <SubFoldersModal masterFolderId= {this.state.masterFolderId} userId={this.state.userId} userTypeName = "STAFF" subFolderId={this.state.subFolderId} closeDialog={this.handleCloseHandler} />}        
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="table-responsive mt-15">
                            <table className={tableClass}>
                                <thead>
                                    <tr>
                                        <th width="50%"><SortingCustom noSort={!userDocumentSubFolderList.length} setSortColumn={this.setSortColumn} columnName='subFolderName' displayName='Name' /></th>
                                        <th width="30%">Active</th>
                                         {this.props.uploadPermission ?
                                            <th width="20%">Actions</th>
                                             : null} 
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderData(userDocumentSubFolderList)}
                                </tbody>
                            </table>
                            {userDocumentSubFolderMeta && userDocumentSubFolderMeta['totalPages'] ?
                                <PaginatorCustom data={userDocumentSubFolderMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        {/* </div> */}
    </div>
    )
}


renderData(userDocumentSubFolderList) {
  userDocumentSubFolderList = userDocumentSubFolderList || [];
  if (!userDocumentSubFolderList.length) {
      return (
          <tr>
              <td colSpan="3">
                  <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No folder found under ' + this.state.masterFolderName}</div>
              </td>
          </tr>
      );
  }
  return userDocumentSubFolderList.map((Obj, index) => {
      return (
          <tr key={index}>
              <td><a href="#" onClick={(e) => this.onClickHandler(e, Obj)}>{Obj.subFolderName}</a></td>              
              <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Yes' : 'No'}</td>
              {this.props.uploadPermission ?
                  <td>
                      <button onClick={(e) => this.handleEditSubFolderClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                      {Obj.documentIds.toString().trim() !== '' && <button onClick={(e) => this.handleMoveFolderDocumentClick(e, Obj)} type="button" title="Move All Documents" className="tbactionbtn bluefont"><i className="fa fa-arrow-up" aria-hidden="true"></i></button>}
                      {Obj.documentIds.toString().trim() === '' && <button onClick={(e) => this.handleDeleteSubFolderClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>}
                  </td>
                  : null
              }
          </tr>
      )
  })
}

  render() {
    return (
      <div className="col-sm-12">
        {this.state.open ? <UploadDocumentModal folderName ={folderNames.MASTER} uploadDocumentObj={this.state.uploadDocumentObj} UserID={this.state.userId} closeDialog={this.handleCloseHandler} documentTypes={this.props.masterDocumentTypesStaff}   userDocumentMasterFolders={this.state.userDocumentMasterFolders.filter((obj) => obj.userId === this.state.userId && obj.userTypeName === 'STAFF')} userDocumentSubFolders={this.state.userDocumentSubFolders.filter((obj) => obj.userId === this.state.userId)} /> : ''}       
          {/* <div className="col-sm-12"> */}
            {/* <h2 className="page_title">Document Upload</h2>
            <div className="clearfix"></div> */}
            {/* <div className="readmin-panel">
              <div className="panel-body"> */}
                {this.renderDocumentListingPanel()}
              {/* </div>
            </div> */}
          {/* </div> */}
      </div>
    );
  }
}

DocumentSubFolderList = reduxForm({
  form: 'DocumentSubFolderListingForm',
})(DocumentSubFolderList);

const selector = formValueSelector('DocumentSubFolderListingForm');

function mapStateToProps(state, ownProps) {
  // debugger;
  // Start For Role Permission
  let userActionPermission = [],
    selectorStartDate = selector(state, 'startDate'),
    selectorEndDate = selector(state, 'endDate');
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'USER');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'USER_DOCUMENT_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let uploadPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'USER_DOCUMENT_LIST_UPLOAD')[0].permission : false;
  let downloadPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'USER_DOCUMENT_LIST_DOWNLOAD')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'USER_DOCUMENT_LIST_DELETE')[0].permission : false;

  // End For Role Permission

  // let staffsByLocation = [];
  // if (state.user.staffsAndPatientsByLocation && state.user.staffsAndPatientsByLocation.data) {
  //   staffsByLocation = state.user.staffsAndPatientsByLocation.data.staff || [];
  // }

  return {
    currentLocationId: state.login.currentLocationId,
    //staffsList: staffsByLocation,
    loading: state.patient.loading,
    masterData: state.user.master_data,
    staffDocs: state.patient.patientDocumentDownload,
    delete_Uploaded_Document: state.patient.delete_Uploaded_Document,
    uploadPermission: uploadPermission,
    downloadPermission: downloadPermission,
    deletePermission: deletePermission,
    userInfo: state.user.userInfo, // staff user ID for documents
    selectorStartDate,
    selectorEndDate,
    userDocumentSubFolderData: state.patient.userDocumentSubFolderList,
    saved_userDocumentSubFolder: state.patient.saved_userDocumentSubFolderList,
    saved_MoveBatchDocumentsIntoFolder: state.patient.saved_MoveBatchDocumentsIntoFolder,    
    inactivated_MoveBatchDocuments: state.patient.inactivated_MoveBatchDocuments,    
    deleted_MoveBatchDocuments: state.patient.deleted_MoveBatchDocuments, 
    deleted_UserDocumentSubFolder: state.patient.deleted_UserDocumentSubFolder, 
    masterDocumentTypesStaff: state.user.master_data && state.user.master_data.masterDocumentTypesStaff ? state.user.master_data.masterDocumentTypesStaff : [],
  };
}


export default connect(mapStateToProps, { getMasterData, documentUploadDownload, uploadedDocumentDownload, deleteUploadedDocument, getStaffsAndPatientsByLocation, PreviewDownloadedDocument, getUserDocumentSubFolderList, BatchInactiveDocuments, BatchActiveDocuments, BatchDeleteDocuments, deleteUserDocumentSubFolder  })(DocumentSubFolderList);



// WEBPACK FOOTER //
// ./src/modules/users/component/staffDocuments/DocumentSubFolderList.js